import Configurations from './components/Configurations';
export default Configurations;